// Institutional analytics: demand (live or snapshot), snapshots list, registration gaps, bottlenecks, impact, AI narratives
export const DP_ANALYTICS_LOAD = 'DP_ANALYTICS_LOAD';
export const DP_ANALYTICS_LOAD_SUCCESS = 'DP_ANALYTICS_LOAD_SUCCESS';
export const DP_ANALYTICS_LOAD_ERROR = 'DP_ANALYTICS_LOAD_ERROR';
export const DP_ANALYTICS_ACT = 'DP_ANALYTICS_ACT';
export const DP_ANALYTICS_ACT_SUCCESS = 'DP_ANALYTICS_ACT_SUCCESS';
export const DP_ANALYTICS_ACT_ERROR = 'DP_ANALYTICS_ACT_ERROR';
export const DP_ANALYTICS_CLEAR = 'DP_ANALYTICS_CLEAR';
